import type {
  CropMetadata,
  ImageCategory,
  ImageOcrStatus,
  Strain,
} from '@shared';
import { api } from './api';

export interface ImageUploadOptions {
  ocrText?: string;
  cropMetadata?: CropMetadata | null;
  sortOrder?: number;
  ocrStatus?: ImageOcrStatus;
}

/** Typed client calls for image upload/management. */
export const imagesApi = {
  upload: (
    strainId: string,
    file: Blob,
    imageCategory: ImageCategory,
    options: ImageUploadOptions = {},
  ): Promise<Strain> => {
    const form = new FormData();
    form.append('image', file);
    form.append('imageCategory', imageCategory);
    if (options.ocrText) form.append('ocrText', options.ocrText);
    if (options.cropMetadata) {
      form.append('cropMetadata', JSON.stringify(options.cropMetadata));
    }
    if (options.sortOrder !== undefined) {
      form.append('sortOrder', String(options.sortOrder));
    }
    if (options.ocrStatus) {
      form.append('ocrStatus', options.ocrStatus);
    }
    return api.upload<Strain>(`/strains/${strainId}/images`, form);
  },
  remove: (imageId: string): Promise<{ deleted: boolean }> =>
    api.del<{ deleted: boolean }>(`/images/${imageId}`),
  setPrimary: (imageId: string): Promise<Strain> =>
    api.post<Strain>(`/images/${imageId}/primary`),
};
